module.exports = __webpack_public_path__ + "img/logoDigitalMarine.b03bd3ed.png";